import { Colors } from "../../components/common/design-system";
import styled from "styled-components";
import { BREAKPOINTS } from "styles/breakpoints";

export const DesktopNav = styled.div`
  width: 272px;
  background-color: #fff;
  border-radius: 30px;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;

  @media (max-width: 760px) {
    display: none;
  }
`;

export const MobileNav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  @media (min-width: 761px) {
    display: none;
  }
`;

export const StyledNavigation = styled.nav`
  height: 100vh;
  width: 100%;
  padding: 42px 24px;

  @media (min-width: ${BREAKPOINTS.MEGA}) {
    padding: 24px;
  }
`;

export const ButtonMenu = styled.button`
  height: 30px;
  border: none;
  background: none;
`;

export const NavigationLogo = styled.img`
  max-width: 250px;
  max-height: 30px;
  margin: 0 auto 12px;
`;

export const NavigationList = styled.ul`
  list-style: none;
  padding-left: 0;
`;

export const NavigationListItem = styled.li`
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 15px 0;
`;

export const Sidebar = styled.div<{ isOpen: boolean }>`
  width: 280px;
  min-height: 100vh;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  background-color: #fff;
  position: fixed;
  top: 0;
  left: ${({ isOpen }) => isOpen ? "0" : "-100%"};
  z-index: 999;
  transition: all 0.3s ease-in-out;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const SDHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom: 1px solid ${Colors.gray[200]};
  margin-bottom: 20px;
`;

export const SidebarOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease-in-out;
  opacity: ${({ isOpen }) => isOpen ? "1" : "0"};
  visibility: ${({ isOpen }) => isOpen ? "visible" : "hidden"};
  z-index: 998;
  backdrop-filter: blur(2px);
`;

export const SDBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0;

  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  ul li {
    list-style: none;
    margin-bottom: 12px;
  }
`;

export const NavigationListLink = styled.a<{ isActive: boolean }>`
  align-items: center;
  color: ${({ isActive }) => isActive ? Colors.orange.accent : Colors.black};
  display: flex;
  text-decoration: none;

  svg {
    margin-right: 12px;
    color: ${({ isActive }) => isActive ? Colors.orange.accent : 'none'};
    fill: ${({ isActive }) => isActive ? Colors.orange.accent : 'none'};
  }
`;

export const NavigationListLinkHeader = styled.p`
  align-items: center;
  color: ${Colors.black};
  display: flex;
  text-decoration: none;
  cursor: pointer;
  margin: 0;

  svg {
    margin-right: 12px;
    color: ${Colors.black};
  }
`;

export const NavigationListSubLink = styled.a<{ isActive: boolean }>`
  align-items: center;
  color: ${({ isActive }) => isActive ? Colors.orange.accent : 'none'};
  display: flex;
  text-decoration: none;
  font-size: 16px;
  margin-left: 36px;
  margin-bottom: 5px;

  svg {
    margin-right: 12px;
    color: ${({ isActive }) => isActive ? Colors.orange.accent : 'none'};
    fill: ${({ isActive }) => isActive ? Colors.orange.accent : 'none'};
  }
`;

export const MobileHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 997;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;